import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import type { TOC } from '@ember/component/template-only';
export interface BvCardFooterSignature {
    Blocks: {
        default: [];
    };
    Element: HTMLDivElement;
}
const BvCardFooterComponent: TOC<BvCardFooterSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <div class='bv-card__footer' ...attributes>
    {{yield}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvCardFooterComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvCard::Footer': typeof BvCardFooterComponent;
        'bv-card/footer': typeof BvCardFooterComponent;
    }
}
